import React from "react";
import EmbedNUrlVideoPlayer from "repoV2/pages/sale/components/EmbedNUrlVideoPlayer/EmbedNUrlVideoPlayer";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import {
    FILE_MIME_DOCS_FORMAT,
    FILE_MIME_IMAGE_FORMAT,
    FILE_MIME_VIDEO_FORMAT,
} from "repoV2/features/Common/modules/Files/Files.constants";
import IconButton from "@mui/material/IconButton";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import styles from "./RenderFilePreview.module.scss";

export const RenderFilePreview = (props: {
    fileUploaded: {
        type?: string;
        value?: string;
    };
    onClick: () => void;
}) => {
    const { fileUploaded, onClick } = props;
    const videoParentRef = React.useRef<any>(null);
    if (!fileUploaded.type) return null;
    const fileType = fileUploaded.type;
    if (Object.values(FILE_MIME_IMAGE_FORMAT).flat().includes(fileType)) {
        return (
            <div className={styles.uploadFileContainerMedia}>
                <div className={styles.uploadFileIconTextContainer}>
                    <img
                        src={fileUploaded.value}
                        alt="Uploaded Preview"
                        className={styles.imageDim}
                    />
                </div>
                <IconButton
                    className={styles.iconButtonStyle}
                    onClick={onClick}
                >
                    <div className={styles.deleteIconContainer}>
                        <DeleteRoundedIcon className={styles.deleteIconStyle} />
                    </div>
                </IconButton>
            </div>
        );
    } else if (
        Object.values(FILE_MIME_VIDEO_FORMAT).flat().includes(fileType)
    ) {
        return (
            <div className={styles.uploadFileContainerMedia}>
                <div className={styles.uploadFileIconTextContainer}>
                    <div className={styles.ParentWrapper} ref={videoParentRef}>
                        <EmbedNUrlVideoPlayer
                            url={fileUploaded.value}
                            videoSrcType="upload_video"
                            parentRef={videoParentRef}
                            volume={0}
                            controls
                            className={styles.VideoPlayer}
                            isMuted
                            width="inherit"
                            height="inherit"
                        />
                    </div>
                </div>
                <IconButton
                    className={styles.iconButtonStyle}
                    onClick={onClick}
                >
                    <div className={styles.deleteIconContainer}>
                        <DeleteRoundedIcon className={styles.deleteIconStyle} />
                    </div>
                </IconButton>
            </div>
        );
    } else if (Object.values(FILE_MIME_DOCS_FORMAT).flat().includes(fileType)) {
        return (
            <div className={styles.uploadFileContainer}>
                <div className={styles.uploadFileIconTextContainer}>
                    <div className={styles.uploadFileText}>
                        <InsertDriveFileRoundedIcon />
                        <div className={styles.fileText}>
                            {fileUploaded.value}
                        </div>
                    </div>
                </div>
                <IconButton
                    className={styles.iconButtonStyleApp}
                    onClick={onClick}
                >
                    <div className={styles.deleteIconContainer}>
                        <DeleteRoundedIcon className={styles.deleteIconStyle} />
                    </div>
                </IconButton>
            </div>
        );
    } else {
        return (
            <div className={styles.uploadFileContainer}>
                <div className={styles.uploadFileIconTextContainer}>
                    <div className={styles.uploadFileText}>
                        <InsertDriveFileRoundedIcon />
                        <div className={styles.fileText}>
                            {fileUploaded?.value}
                        </div>
                    </div>
                </div>
                <IconButton
                    className={styles.iconButtonStyleApp}
                    onClick={onClick}
                >
                    <div className={styles.deleteIconContainer}>
                        <DeleteRoundedIcon className={styles.deleteIconStyle} />
                    </div>
                </IconButton>
            </div>
        );
    }
};
